export default __webpack_public_path__ + "static/Roobert-Bold-3a53075cbb88d1303a6f41f4e23e9fb3.woff";